export enum CompanyGradeExpirationCode {
  NO_REFRESH_DATE = 'NO_REFRESH_DATE',
  LAST_REFRESH_TOO_OLD = 'LAST_REFRESH_TOO_OLD',
  LAST_REFRESH_UP_TO_DATE = 'LAST_REFRESH_UP_TO_DATE',
}
